import { IconVideo, IconX } from '@tabler/icons-react';

export function VideoFileRow({ name, meta, onRemove, removeLabel, dragHandle, orderBadge }) {
    return (
        <div className="flex animate-[toolSlide_0.4s_cubic-bezier(0.2,0.8,0.25,1)_both] items-center gap-2.5 rounded-xl border border-[#ECE8E4] bg-white px-2.5 py-2 dark:border-zinc-700 dark:bg-zinc-900">
            {dragHandle ? (
                <span className="flex-none cursor-grab text-[#A8A099] active:cursor-grabbing" aria-hidden="true">
                    {dragHandle}
                </span>
            ) : null}
            {orderBadge ? (
                <span className="flex h-6 w-6 flex-none items-center justify-center rounded-md bg-violet-50 text-[11px] font-bold text-violet-600 dark:bg-violet-900/30 dark:text-violet-400">
                    {orderBadge}
                </span>
            ) : null}
            <div className="flex h-10 w-10 flex-none items-center justify-center rounded-lg bg-violet-50 text-violet-600 dark:bg-violet-900/30 dark:text-violet-400">
                <IconVideo size={20} stroke={1.7} />
            </div>
            <div className="min-w-0 flex-1 leading-snug">
                <div className="truncate text-[13px] font-semibold text-[#1C1815] dark:text-zinc-100">{name}</div>
                {meta ? (
                    <div className="text-[11px] text-[#A8A099] dark:text-zinc-500">{meta}</div>
                ) : null}
            </div>
            {onRemove ? (
                <button
                    type="button"
                    onClick={onRemove}
                    aria-label={removeLabel}
                    className="flex h-7 w-7 flex-none items-center justify-center rounded-md bg-[#F7F5F3] text-[#6B635C] transition-colors hover:bg-violet-50 hover:text-[#D33A2C] dark:bg-zinc-800 dark:text-zinc-400"
                >
                    <IconX size={14} stroke={2} />
                </button>
            ) : null}
        </div>
    );
}
